import url from "../../config/url";
import axios from "axios";
import _ from 'lodash';

const state = {
    currentDate: new Date(),
    details: null,
    released: false,
    hideAnotherLine : false,
    timeEntries: [],
    timeEntriesClone: null,
    monthUnreleased : [],
    bookingNodes: [],
    positions: [],
    timeEntry: { // dummy data to push
        date: null,
        positionId: null,
        bookingId: null,
        actualTime: null,
        from: null,
        to: null,
        description: null,
        totalTime: "00:00:00"
    },
    selectedRows: [],
    validateObj: null,
    monthlyData:[],
    partimeDays:[],
    internalPositionTimes:[],
    saveFlag: false
};

const mutations = {
    // set Employee value
    setUserDetails: (state, value) => { state.details = Object.freeze(value.item1); state.released = Object.freeze(value.item2 != null) },
    // set QTime Entries value
    setQTimeEntries: (state, value) => { state.timeEntries = Object.freeze(value); state.timeEntriesClone = Object.freeze(_.cloneDeep(value)) },
    // set QTime Entries value
    setQTimeNodes: (state, value) => state.bookingNodes = Object.freeze(value),
    // set QTime Entries value
    setQTimePositions: (state, value) => state.positions = Object.freeze(value),
    // set current date value
    setCurrentDate: (state, value) => state.currentDate = value,

    setSaveFlag:(state, value) => state.saveFlag = Object.freeze(value),

    setInternalPositionTImes:(state, value) => state.internalPositionTimes = Object.freeze(value),
    
    setMonthUnreleased:(state, value) => state.monthUnreleased = value,

    setQTimeEntriesClone: (state, value) => { state.timeEntriesClone = Object.freeze(_.cloneDeep(value)) },

    setHideAnotherLine: (state,value) => state.hideAnotherLine = Object.freeze(value),

    setIdForNewTimeEntry: (state, value) => 
    { 
        var newItem = state.timeEntries.find(element => element.id === undefined);
        newItem.id = value;
    },
    /**
     * Add new row to the time entries
     * @param state
     */
    addAnotherTimeRow: state => {
        // clone the current data
        let timeEntries = _.cloneDeep(state.timeEntries);
        // clone the dummy entry for new row
        let timeEntryRow = _.cloneDeep(state.timeEntry);
        // set current date new row object
        timeEntryRow.date = state.currentDate;
        // Added to fix Delete bug: https://podio.com/qcentriscom/project-qforecast/apps/development-feedback/items/64
        timeEntryRow.uuid= Date.now();
        // push new row into the current data
        timeEntries.push(timeEntryRow);
        // set the entries list back to store
        state.timeEntries = timeEntries;
    },
    /**
     * Set booking node id on selecting the option from drop down
     * Field is bind with the store value using the index
     * @param state
     * @param data {id,value}
     */
    setBookingNodeId: (state, data) => {
        // clone the time entries list
        let timeEntries = _.cloneDeep(state.timeEntries);
        // get the current entry using the index, if exists
        if (timeEntries[data.id]) {
            // set the current entry
            let currentEntry = timeEntries[data.id];
            // change the current entry booking data
            currentEntry.bookingId = data.value.itemId;
            // update the entry list back with the new data
            state.timeEntries = timeEntries;
        }
    },
    /**
     * Set booking position id on selecting the option from drop down
     * Field is bind with the store value using the index
     * @param state
     * @param data {id,value}
     */
    setPositionId: (state, data) => {
        // clone the time entries list
        let timeEntries = _.cloneDeep(state.timeEntries);
        // get the current entry using the index, if exists
        let currentEntry = timeEntries[data.id];

        if (currentEntry && data.value != null) {
            // change the current entry booking data
            currentEntry.positionId = data.value.itemId;
            // update the entry list back with the new data
            state.timeEntries = timeEntries;
        }
    },
    removeTimeEntry: (state, index) => {
        let entries = _.cloneDeep(state.timeEntries);
        entries.splice(index, 1);
        state.timeEntries = entries;
        
        let entriesClone = _.cloneDeep(state.timeEntriesClone);
        entriesClone.splice(index, 1);
        state.timeEntriesClone = entriesClone;
    },
    pinUnpinEntry: (state, index) => {
        // clone the time entries list
        let timeEntries = _.cloneDeep(state.timeEntries);
        let timeEntriesClone = _.cloneDeep(state.timeEntriesClone);

        // get the current entry using the index, if exists
        if (timeEntries[index]) {
            // set the current entry
            let currentEntry = timeEntries[index];
            // change the current entry booking data
            currentEntry.pinned = !currentEntry.pinned;
            // update the entry list back with the new data
            state.timeEntries = timeEntries;

            let currentEntryClone = timeEntriesClone[index];
            currentEntryClone.pinned = !currentEntryClone.pinned;
            state.timeEntriesClone = timeEntriesClone;
        }
    },
    setSelectedRows: (state,value) => state.selectedRows = value,
    checkAll: state => {
        let allIds = state.timeEntries.map(function (val) {
            var posIds=state.positions.filter(x=>x.bookingNode==val.bookingId && x.itemId==val.positionId);
            if(!((posIds !=null && posIds[0].description === "Locked") && (posIds !=null && posIds[0].actualHours === "Locked") && (posIds !=null && posIds[0].fromTo === "Locked")))
            return val.id
        })
        state.selectedRows = allIds.filter( Number );
    },
    uncheckAll: state => {
        state.selectedRows = [];
    },
    setValidateData: (state,value) => state.validateObj = value,
    setMonthlyData: (state,value) => state.monthlyData = value,
    setPartimeDays: (state,value) => state.partimeDays = value
};
const actions = {
    /**
     * Fetch Qtime data
     * @param commit
     * @param date
     * @returns {Promise<unknown>}
     */
    fetchQTime: function ({commit, state}) {
        //commit("setGlobalLoader", true);
        let date = {date: state.currentDate.toDateString()};
        //let date = {date: "2019-01-01T00:00:00"};
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_api, date)
                .then(
                    response => {
                        if (response.data.responseObject) {
                            var newItem = state.timeEntries.find(element => element.id === undefined);
                            if(newItem!== undefined && newItem!== null){
                                var dbItems = response.data.responseObject.timeEntries.item1;
                                var newIdFromDb = dbItems[dbItems.length - 1]
                                if(newItem.bookingId === newIdFromDb.bookingId){
                                    commit("setIdForNewTimeEntry", newIdFromDb.id);
                                    commit("setQTimeEntriesClone", state.timeEntries);
                                }       
                            }
                            else{
                                commit("setQTimeEntries", response.data.responseObject.timeEntries.item1);
                            }
                            commit("setUserDetails", response.data.responseObject.details);
                            //commit("setUserDetails", response.data.responseObject.details);                            
                            //commit("setQTimeEntries", response.data.responseObject.timeEntries.item1);
                            commit("setQTimeNodes", response.data.responseObject.timeEntries.item3);
                            commit("setQTimePositions", response.data.responseObject.timeEntries.item4);
                            commit("setMonthlyData", response.data.responseObject.monthlyData);
                            commit("setPartimeDays", response.data.responseObject.details.item3);

                            if((state.timeEntries === null || state.timeEntries.length === 0) && !state.released && response.data.responseObject.timeEntries.item2 != null){
                                let currDateClone = _.cloneDeep(state.currentDate);

                                response.data.responseObject.timeEntries.item2.forEach(element => {
                                    element.date = currDateClone;
                                    element.parentPinnedId = element.id;
                                    element.id = 0;
                                    element.from=null;
                                    element.to=null;
                                    element.actualTime=null;
                                    element.description=null;
                                    element.totalTime = "00:00:00";
                                    
                                });
                                commit("setQTimeEntries", response.data.responseObject.timeEntries.item2);

                            }
                            
                            else if((state.timeEntries != null || state.timeEntries.length > 0) && !state.released && response.data.responseObject.timeEntries.item2 != null && response.data.responseObject.timeEntries.item2.length >0 ){
                                let currDateClone = _.cloneDeep(state.currentDate);
                                response.data.responseObject.timeEntries.item2.forEach(element => {
                                    element.date = currDateClone;
                                    element.parentPinnedId = element.id;
                                    element.id = 0;
                                    element.from=null;
                                    element.to=null;
                                    element.actualTime=null;
                                    element.description=null;
                                    element.totalTime = "00:00:00";
                                });
                                let combined=response.data.responseObject.timeEntries.item1.concat(response.data.responseObject.timeEntries.item2)
                                commit("setQTimeEntries", combined);

                            }


                            resolve(true);
                        } else {
                            reject(false);
                        }
                        //commit("setGlobalLoader", false);
                        //commit("setUpdateIcon", false);
                        commit("setSaveFlag", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        //commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Fetch Qtime data
     * @param commit
     * @param date
     * @returns {Promise<unknown>}
     */
    goToDate: function ({commit, state}, changeDate) {
        commit("setGlobalLoader", true);
        commit("setUpdateIcon", false);
        commit("setQTimeEntries", []);
        state.currentDate = changeDate;
        let newDate = {date: changeDate.toDateString()};
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_api, newDate)
                .then(
                    response => {
                        if (response.data.responseObject) {
                            commit("uncheckAll");
                            commit("setUserDetails", response.data.responseObject.details);
                            /*
                            let currDateClone = _.cloneDeep(state.currentDate);
                            response.data.responseObject.timeEntries.item1.forEach(element => {
                                
                                if(element.pinned==true){
                                    element.date = currDateClone;
                                    element.parentPinnedId = element.id;
                                    //element.id = 0;

                                }
                               
                            });
                            */
                            commit("setQTimeEntries", response.data.responseObject.timeEntries.item1);
                            commit("setQTimeNodes", response.data.responseObject.timeEntries.item3);
                            commit("setQTimePositions", response.data.responseObject.timeEntries.item4);
                            commit("setMonthlyData", response.data.responseObject.monthlyData);
                            commit("setPartimeDays", response.data.responseObject.details.item3);
                            
                            if((state.timeEntries === null || state.timeEntries.length === 0) && !state.released && response.data.responseObject.timeEntries.item2 != null){
                                let currDateClone = _.cloneDeep(state.currentDate);

                                response.data.responseObject.timeEntries.item2.forEach(element => {
                                    element.date = currDateClone;
                                    element.parentPinnedId = element.id;
                                    element.id = 0;
                                    element.from=null;
                                    element.to=null;
                                    element.actualTime=null;
                                    element.description=null;
                                    element.totalTime = "00:00:00";
                                
                                });
                                commit("setQTimeEntries", response.data.responseObject.timeEntries.item2);

                            }
                            
                            else if((state.timeEntries != null || state.timeEntries.length > 0) && !state.released && response.data.responseObject.timeEntries.item2 != null){
                                let currDateClone = _.cloneDeep(state.currentDate);

                                response.data.responseObject.timeEntries.item2.forEach(element => {
                                    element.date = currDateClone;
                                    element.parentPinnedId = element.id;
                                    element.id = 0;
                                    element.from=null;
                                    element.to=null;
                                    element.actualTime=null;
                                    element.description=null;
                                    element.totalTime = "00:00:00";
                                });
                                let combined=response.data.responseObject.timeEntries.item1.concat(response.data.responseObject.timeEntries.item2)
                                commit("setQTimeEntries", combined);

                            }

                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Upasert Qtime data
     * @param commit
     * @param date
     * @returns {Promise<unknown>}
     */
    saveToDb: function ({commit, state},excludeTimeEntryIds) {
        commit("setprogressIcon", true);
        commit("setUpdateIcon", false);
        commit("seterrorSaveIcon", false);
        commit("setSaveFlag", true);
        let timeEntriesForSave = state.timeEntries;
        if(excludeTimeEntryIds !== undefined){
            timeEntriesForSave = state.timeEntries.filter(timeEntry => !excludeTimeEntryIds.includes(timeEntry.id));

        }

        return new Promise((resolve, reject) => {
            axios.post(url.qtime_post_api, timeEntriesForSave)
                .then(
                    response => {
                        if (response.data.status) {
                            //commit("setQTimeEntries", []);
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setUpdateIcon", true);
                        commit("setprogressIcon", false);
                        commit("seterrorSaveIcon", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setUpdateIcon", false);
                        commit("setprogressIcon", false);
                        commit("seterrorSaveIcon", true);
                    }
                )
        })
    },
    /**
     * Delete Qtime data
     * @param commit
     * @param date
     * @param dbId
     * @returns {Promise<unknown>}
     */
    deleteFromDb: function ({commit}, dbId) {
        commit("setGlobalLoader", true);

        return new Promise((resolve, reject) => {
            axios.get(url.qtime_del_api + '/?id=' + dbId)
                .then(
                    response => {
                        if (response.data.status) {
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Delete Qtime data for a list of items
     * @param commit
     * @param date
     * @param dbId
     * @returns {Promise<unknown>}
     */
    deleteListFromDb: function ({commit}) {
        commit("setGlobalLoader", true);
        let dateWithIds = { Date : state.currentDate.toDateString(), ItemIds : state.selectedRows };

        return new Promise((resolve, reject) => {
            axios.post(url.qtime_del_list_api, dateWithIds)
                .then(
                    response => {
                        if (response.data.status) {
                            state.selectedRows = [];
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Pin / UnPin Qtime entry
     * @param status
     * @param dbId
     * @returns {Promise<unknown>}
     */
    pinUnpin: function ({commit}, pinDetails) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios.get(url.qtime_pin_api + '/?id=' + pinDetails.id + '&status=' + pinDetails.pinState)
                .then(
                    response => {
                        if (response.data.status) {
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Copy selected entries to another date
     * @param commit
     * @param dateWithIds
     * @returns {Promise<unknown>}
     */
    copyToDate: function ({commit, state}, toDate) {
        commit("setGlobalLoader", true);
        let dateWithIds = { Date : [toDate.start, toDate.end] , ItemIds : state.selectedRows };
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_copy_api, dateWithIds)
                .then(
                    response => {
                        if (response.data.status) {
                            commit("uncheckAll");
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Release All by date
     * @param commit
     * @param releaseDate
     * @returns {Promise<unknown>}
     */
    releaseAll: function ({commit}, releaseDate) {
        commit("setGlobalLoader", true);
        let dateObj = { Date : releaseDate.toDateString() };
        
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_release_api, dateObj)
                .then(
                    response => {
                        if (response.data.status) {
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Validate before release by date
     * @param commit
     * @param releaseDate
     * @returns {Promise<unknown>}
     */
    validateRelease: function ({commit}, releaseDate) {
        commit("setGlobalLoader", true);
        commit("setValidateData", null);
        let dateObj = { Date : releaseDate.toDateString() };
        
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_validate_api, dateObj)
                .then(
                    response => {
                        
                        if (response.data.status) {
                            commit("setValidateData", response.data.responseObject);
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    updateHideAnotherLine({ commit }, value) {
        commit('setHideAnotherLine', value);
    },
    unreleasedMonth: function ({commit, state}) {
        // commit("setGlobalLoader", true);
        let date = {date: state.currentDate.toDateString()};
        return new Promise((resolve, reject) => {
            axios.post(url.qtime_unreleasedmonth_api, date)
                .then(
                    response => {
                        
                        if (response.data.responseObject) {
                            commit("setMonthUnreleased", response.data.responseObject.monthlyReleasedFlag);
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        //commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        //commit("setGlobalLoader", false);
                    }
                )
        })
    },
    setGlobalLoaderInitial: function ({commit, state}) {
         commit("setGlobalLoader", true);
    },
    setGlobalLoaderInitialfalse: function ({commit, state}) {
         commit("setGlobalLoader", false);
    },
    internalPositionTimes: function ({commit, state}) {
        // commit("setGlobalLoader", true);
        let date = {date: state.currentDate.toDateString()};
        return new Promise((resolve, reject) => {
            axios.post(url.internalposition_time, date)
                .then(
                    response => {
                        if (response.data.responseObject) {
                            commit("setInternalPositionTImes", response.data.responseObject.internalPositionTimes);
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        //commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        //commit("setGlobalLoader", false);
                    }
                )
        })
    },
};
export default {
    state,
    mutations,
    actions
}
